jQuery(document).ready(function() {
  $("#vdo_banner_btn").click(function () {
    $("#vdo_banner_popup, .modal-backdrop").addClass('show_modal');
  });
  $("#close_btn").click(function () {

    $("#vdo_banner_popup, .modal-backdrop").removeClass('show_modal');
    var video = $(".js-youtube").attr("src");
      $(".js-youtube").attr("src","");
      $(".js-youtube").attr("src",video);
  });
  
  $('.mini-order-note').hide();
  $('.submit-order-note').hide();
  if ($(window).width() < 991) {
    $(".banner_section_home .banner_section").addClass('mobile');
  }
  
  $(document).on("click",".search_btn_js",function() {  
    $(".search_modal, body").toggleClass('search_open');
  });
  
  $(".js-drawer-close").click(function () {
    $(".search_modal, body").removeClass('search_open');
  });
  
  $(".search_mobile_click").click(function(){
      $(".mobile-search ").css("display", "block");
  });

  $(".close-search").click(function(){
      $(".mobile-search ").css("display", "none");
  });
  
  // let w = $('.section .container').width();
  // let win_width = $( document ).width();
  // let apply_margin = (win_width - w) / 2;
  // let max_width = (win_width - apply_margin);
  // $(".product_slider_collection .page-width, .you_maylike_slider .page-width").css({'margin-left': apply_margin});
  // $(".product_slider_collection .page-width, .you_maylike_slider .page-width").css({'max-width': max_width});

   $('.review_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        speed: 1000
    });
  
   $('.prd_slider_js').slick({
        slidesToShow: 3,
        slidesToScroll: 2,
        arrows: false,
        dots: false,
        speed: 1000,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 690,
            settings: {
              slidesToShow: 1,
            }
          }
    	]
    });

   $('.slider_marqu').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 10000,
        dots: false,
        arrows:false,
        variableWidth: true,
        cssEase: 'linear',
        pauseOnFocus: false, 
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              speed: 8000
            }
          }
        ]
   });
  
});

$(window).on('load', function() {

  $('.drawer__close').on('click', function(){

    $(".top-bar--right-menu .cart-container, .cart_mobile .cart-container, body").removeClass('cart_active active_link blocked-scroll');
  });

  let w = $('.section .container').width();
  let win_width = $( document ).width();
  let apply_margin = (win_width - w) / 2;
  let max_width = (win_width - apply_margin);

  
    $('.you_maylike_slider .product-list').slick({
        slidesToShow: 3,
        slidesToScroll: 2,
        arrows: false,
        dots: false,
        speed: 1000,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 690,
            settings: {
              slidesToShow: 1,
            }
          }
    	]
    });
   });
// Newsletter JS

// setTimeout(function() {
//   $(".newsletter-form__field-wrapper").fadeOut().empty();
//   $(".newsletter-form__field-wrapper-success").fadeOut().empty();
// }, 5000);

// var live_url = window.location.href;
// var result = live_url.includes('form_type=customer');
// var thankyou = live_url.includes('customer_posted=true#contact_form');

// if(result){
//     const add_ele = document.createElement("h3");
//     add_ele.innerText = "Email ID Already Registered OR You Have Entered a Wrong Email!";
//     document.querySelector('.newsletter-form__field-wrapper').appendChild(add_ele);
//     add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
// }else if(thankyou){
//     const add_ele_success = document.createElement("h4");
//     add_ele_success.innerText = "Success!";
//     document.querySelector('.newsletter-form__field-wrapper-success').appendChild(add_ele_success);
//     add_ele_success.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
// }

// Newsletter JS
if (window.location.href.indexOf("cart") > -1) {
}else{
  $(document).on("click",".mini_cart",function() {  
    $(".top-bar--right-menu .cart-container, body").addClass('cart_active');
    return false;
  });
}

if (window.location.href.indexOf("cart") > -1) {
}else{
  $(document).on("click",".mini_cart",function() {  
    $(".cart_mobile .cart-container, body").addClass('cart_active');
    return false;
  });
}  

// $('.drawer__close').on('click', function(){
//   $(".top-bar--right-menu .cart-container, .cart_mobile .cart-container, body").removeClass('cart_active');
// });
 $(document).click(function (e) {
    if (!$(e.target).closest('.cart-container .cart_content').length) {
        $(".top-bar--right-menu .cart-container, .cart_mobile .cart-container, body").removeClass('cart_active');
    }
  });

$('.add-order-note').on('click', function(){
  $(this).hide();
  $('.mini-order-note').show();
  $('.submit-order-note').show();
});

$('.submit-order-note').on('click', function(){
  $(this).hide();
  $('.mini-order-note').hide();
  $('.add-order-note').show();
});

$(document).on("click","body",function() {
  $('.mega-menu-parent').removeClass('active_link');
});

$(document).on("click",".rc_widget__option--subsave",function() {
  $(this).parents().addClass('active');
});

$(document).on("click",".rc_widget__option--onetime",function() {
  $(this).parents().removeClass('active');
});
               
setTimeout(function () {
  $('.mega-menu-parent').mouseleave(function() {
    $(this).removeClass('active_link');
  });
}, 2500);

// Update the mega menu top position when scrolling the window
$(document).on("scroll", function() {
  const scrollTop = $(window).scrollTop();
  if (scrollTop < 110) {
    const top = $("[data-body-content]").offset().top - scrollTop;
    $(".mega-menu.dropdown_container").css("top", `${top}px`);
  } else {
    $(".mega-menu.dropdown_container").css("top", "100%");
  }
})
